import React from 'react';
import { useLocation } from 'react-router-dom';
import Report from './Report';

const SubmitPage = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    let type = queryParams.get('type');
    
    if (type === 'ServiceRequest') {
        type = 'Service Request';
    } else if (type === 'Report') {
        type = 'Report a Condition';
    }

    return <Report type={type}/>;
};

export default SubmitPage;